import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function ResetPassword() {
  const [password, setPassword]   = useState('')
  const [confirm, setConfirm]     = useState('')
  const [loading, setLoading]     = useState(false)
  const [error, setError]         = useState('')
  const [success, setSuccess]     = useState(false)
  const [validLink, setValidLink] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    // Supabase puts the session tokens in the URL hash when user clicks the email link
    // onAuthStateChange picks up the RECOVERY event automatically
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        setValidLink(true)
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  const handleReset = async (e) => {
    e.preventDefault()
    setError('')
    if (password !== confirm) { setError('Passwords do not match.'); return }
    if (password.length < 8)  { setError('Password must be at least 8 characters.'); return }

    setLoading(true)
    const { error } = await supabase.auth.updateUser({ password })
    if (error) {
      setError(error.message)
    } else {
      setSuccess(true)
      setTimeout(() => navigate('/login'), 3000)
    }
    setLoading(false)
  }

  return (
    <div className="auth-layout">
      <div className="auth-panel">
        <div className="auth-panel-content">
          <div className="auth-logo">
            <div className="auth-logo-mark">↑</div>
            <span className="auth-logo-name">Uplift</span>
          </div>
          <h1>Set your new password</h1>
          <p>Choose a strong password you haven't used before. You'll use it to sign in from now on.</p>
          <div className="auth-panel-features">
            <div className="auth-feature">
              <div className="auth-feature-icon">✅</div>
              At least 8 characters
            </div>
            <div className="auth-feature">
              <div className="auth-feature-icon">🔐</div>
              Keep it somewhere safe
            </div>
          </div>
        </div>
      </div>

      <div className="auth-form-side">
        <div className="auth-card">
          <div className="auth-card-logo">
            <div className="auth-card-logo-mark">↑</div>
            <span className="auth-card-logo-name">Uplift</span>
          </div>
          <h2>Set new password</h2>
          <p className="subtitle">Almost done — just choose a new password</p>

          {error   && <div className="alert alert-error">⚠ {error}</div>}
          {success && <div className="alert alert-success">✓ Password updated! Redirecting you to sign in…</div>}

          {!validLink && !success && (
            <div className="alert alert-error">
              ⚠ This link is invalid or has expired. Please <a href="/forgot-password">request a new reset link</a>.
            </div>
          )}

          {validLink && !success && (
            <form onSubmit={handleReset}>
              <div className="form-group">
                <label>New password</label>
                <input
                  type="password" required
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="At least 8 characters"
                  autoComplete="new-password"
                />
              </div>
              <div className="form-group">
                <label>Confirm new password</label>
                <input
                  type="password" required
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  placeholder="Repeat your new password"
                  autoComplete="new-password"
                />
              </div>
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? 'Updating…' : 'Update password →'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}
